import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./ProductImage.module.css";

/**
 * Renders a product image, falling back to a sized placeholder showing the
 * item's title when there's no src or the image fails to load. Browsers
 * don't reliably constrain a broken <img>'s fallback alt text inside its
 * box, so we swap to a real element sized by the caller's className instead.
 */
export function ProductImage({ src, alt, className }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  if (!src || hasError) {
    return (
      <div
        className={`${className ?? ""} ${styles.placeholder}`}
        role="img"
        aria-label={alt}
        title={alt}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {alt}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setHasError(true)}
    />
  );
}

ProductImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default ProductImage;
